import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./componentes/Navbar/Navbar";
import Footer from "./componentes/Footer/Footer";
import "./MainLayout.scss";

const MainLayout = () => {
  return (
    <div className="main-layout">
      <Navbar />
      <main className="main-layout__content">
        <Outlet /> 
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
